module.exports = __webpack_public_path__ + "img/violet_117.0f7e78c9.png";